import { useEffect, useState } from "react";
import { Flame } from "lucide-react";
import { scrollToId } from "@/lib/scroll";

const LINKS = [
  { label: "Episode One", href: "#episode", testId: "nav-link-episode" },
  { label: "The Experience", href: "#experience", testId: "nav-link-experience" },
  { label: "Ritual", href: "#ritual", testId: "nav-link-ritual" },
  { label: "Episodes", href: "#seasons", testId: "nav-link-episodes" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`fixed inset-x-0 top-0 z-50 transition-[background-color,border-color,backdrop-filter] duration-500 ${
        scrolled
          ? "border-b border-gold/10 bg-obsidian/80 backdrop-blur-md"
          : "border-b border-transparent bg-transparent"
      }`}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-5 sm:px-12">
        <button
          data-testid="nav-brand"
          onClick={() => scrollToId("#top")}
          className="group flex items-center gap-3"
        >
          <Flame className="h-4 w-4 text-gold transition-transform duration-500 group-hover:scale-125" />
          <span className="font-cinzel text-xs tracking-[0.35em] text-cream sm:text-sm">
            IMMERSIVE AT HOME
          </span>
        </button>
        <nav className="hidden items-center gap-10 md:flex">
          {LINKS.map((link) => (
            <button
              key={link.href}
              data-testid={link.testId}
              onClick={() => scrollToId(link.href)}
              className="text-[11px] uppercase tracking-[0.25em] text-sand transition-colors duration-300 hover:text-gold"
            >
              {link.label}
            </button>
          ))}
        </nav>
        <button
          data-testid="nav-reserve-button"
          onClick={() => scrollToId("#join")}
          className="rounded-full border border-gold/40 px-5 py-2 text-[11px] uppercase tracking-[0.22em] text-gold transition-all duration-300 hover:bg-gold hover:text-obsidian"
        >
          Reserve a Box
        </button>
      </div>
    </header>
  );
};
